export default __webpack_public_path__ + "static/media/edit.7a740293.svg";